/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Header,
} from 'semantic-ui-react';

export default class BookingTitle extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]).isRequired,
    isMobile: PropTypes.bool,
  }
  static defaultProps = {
    isMobile: false,
  }
  static getPropsToState = (props) => {
    const data = props.data;
    return {
      data,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingTitle.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingTitle.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  render() {
    const { isMobile } = this.props;
    const { data } = this.state;
    const columnStyle = { paddingBottom: '0' };
    if (isMobile) columnStyle.padding = '0';
    return (
      <Grid>
        <Grid.Row style={{ paddingBottom: '0' }}>
          <Grid.Column textAlign="center" style={columnStyle}>
            {/*
            <Label.Group size={isMobile ? 'mini' : 'medium'}>
              {data && data.projectUnit ?
                <Label basic style={{ cursor: 'text' }}>
                  <b>{data.projectUnit.reference}</b>
                </Label>
                : ''
              }
              {data && data.project && data.project.name ?
                <Label basic style={{ cursor: 'text' }}>
                  <b>{data.project.name}</b>
                </Label>
                : ''
              }
              {data && data.code ?
                <Label basic style={{ cursor: 'text' }}>
                  <b>{data.code}</b>
                </Label>
                : ''
              }
            </Label.Group>
            */}
            <div>
              <Header as="h3" style={{ marginBottom: '0' }}>{data && data.projectUnit && data.projectUnit.reference ? data.projectUnit.reference : ''}</Header>
              <b>{data && data.project && data.project.name ? data.project.name : ''}</b><br />
              <span>{data && data.code ? data.code : ''}</span>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/BookingTitle.jsx